import React from 'react';
import { Link } from 'react-router-dom';
import todoLogo from "../images/TodoMate-logo.png";



const VerificationEmailSent = () => {

    

    return (
        <>

            <Link className='flex mt-12 justify-center text-blue-300' to="/">
                <img src={todoLogo} className=' w-[80px] h-[80px]' alt="todo logo" />
            </Link>
            <div className='w-[250px] h-[420px]   xs:w-[340px] xs:h-[350px]    sm:w-[450px] sm:h-[340px]  mobLg:h-[340px] md:h-[340px] smLaptop:h-[340px] lg:h-[340px]  xl:w-[450px] xl:h-[340px]  container mt-[-40px] mx-auto border-2 border-gray-300 rounded-md'>
                <div className='w-[240px]  xs:w-[320px] sm:w-[400px] xl:w-[400px] mx-auto mt-16'>
                    <div className='text-3xl mt-8 text-center  text-[#183e70] font-bold '>
                        Email Verification
                    </div>
                    <div className='mt-6 text-center text-[#142e52]'>
                        <div>Verification email has been sent your email address.</div>
                        <div>Please verify your email before proceeding.</div>
                        <div>Once your email is verified, you can <span> <Link className='font-medium underline text-blue-700' to="/signin">Login</Link></span> </div>
                        <div className='text-xs mt-10'>Note: If you haven't received the email, please check your spam or junk folder. If it's not there either, we recommend waiting for 5 minutes and then check back. </div>
                    </div>
                </div>
            </div>
        </>
    )
}



export default VerificationEmailSent;